module.exports = __webpack_public_path__ + "img/belt.71ce2c40.png";